module.exports = __webpack_public_path__ + "54e3bcf9319b8cce1a6ff9a720874683.png";